import React, { useState, useEffect, useContext } from "react";
import { Container } from "react-bootstrap";
import getFilePath from "helpers/get-file-path";
import RichText from "components/rich-text";
import Image from "components/image";
import {
  mediaTab, mediaTabButtons, mediaTabContainer, mediaTabText,
  mediaTabButtonsItem, buttonActive, mediaTabItem, mediaTabImage,
  tabActive, mediaTabVideo, mediaTabItemReverse,
  mediaTabButtonsDesktop, mediaTabButtonsMobile,
  responsiveContainer, mediaTabButtonsContainer,
  productsMediaItem, productsMediaTab, mainTitle,
  productsMediaTabButtons, prodImage, selectedMediaItem,
  fullOpacityImage, transparentImage, notActiveButton
} from "./style.mod.scss";
import { lazyLoadVideos } from "helpers/lazyLoadVideos";
import getImagePath from "helpers/get-image-path";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import ProductContext from "services/product-context";
import { trackTabClick } from "helpers/analytics";

const ProductsMediaTab = ({ data }) => {
  const [tabActiveKey, setTabActive] = useState(null);
  const { tabs } = data;
  const isButtonActive = (_key, index) => (!tabActiveKey && index === 0) || (tabActiveKey === _key);
  const [selectedTitle, setSelectedTitle] = useState("");
  const prodContext = useContext(ProductContext);
  const id = prodContext?.currentVariant?.category?.parentCategory?.id;
  const currentVariantHandle = prodContext?.currentVariant?.handle?.current;

  useEffect(() => {
    lazyLoadVideos();
  }, []);

  let settings = {
    slidesPerView: 4,
    spaceBetween: 10,
    loop: false,
    dots: true,
    centeredSlides: true,
    modules: [Pagination],
    pagination: { clickable: true },
    navigation: { clickable: true },
    breakpoints: {
      567: {
        slidesPerView: 3,
        spaceBetween: 20,

      },
      1200: {
        spaceBetween: 25,
        slidesPerView: 4.3,
      }
    }
  };

  const [firstItem, setFirstItem] = useState(null);
  useEffect(() => {
    if (tabs && tabs.length > 0) {
      setFirstItem(tabs[0]);
      setSelectedTitle(tabs[0]?.title);
    }
  }, [tabs, firstItem]);

  if (id !== "sets-aluminium" && data?.showModule) return <></>;

  const variantsTab = tabs?.filter((tab) =>
    tab?.variantsRef?.some((variant) => variant?.handle === currentVariantHandle)
  );

  if (!variantsTab?.length) return <></>;

  return (
    <div className={`${mediaTab} ${productsMediaTab} ${(data.alternate) ? mediaTabItemReverse : ""}`}
      style={{ backgroundColor: data.bgColor && data.bgColor.hex }} >
      <Container className={responsiveContainer}>
        {data?.title &&
          <h2 className={mainTitle}>{data?.title}</h2>}
        <div className={`${mediaTabButtons} ${mediaTabButtonsDesktop} ${productsMediaTabButtons}`}>
          {
            variantsTab?.map((tab, index) => {
              const { title, _key } = tab;
              return (
                <div key={_key} className={productsMediaItem} onClick={() => {
                  setTabActive(_key);
                  trackTabClick(title);
                }}>
                  <div className={prodImage}>
                    <img src={getImagePath(tab?.productImage)} />
                  </div>
                  <button
                    className={`${mediaTabButtonsItem} ${isButtonActive(_key, index) ? buttonActive : notActiveButton}`}>
                    {title}
                  </button>
                </div>
              );
            })
          }
        </div>
        <div className={mediaTabContainer}>
          {
            variantsTab?.map((tab, index) => {
              const { video, _key, image, text, videoURL } = tab;
              const alt = image?.alt?.replace("Olav ", "Olavson ");
              return (
                <div key={_key} className={`${mediaTabItem} ${((tabActiveKey === null && index === 0) || (tabActiveKey === _key)) && tabActive}`}>
                  <div className={mediaTabText}>
                    <RichText blocks={text} />
                  </div>
                  <div className={mediaTabImage}>
                    {
                      video ?
                        <video
                          autoPlay
                          loop
                          muted
                          playsInline
                          className={mediaTabVideo}
                        >
                          <source data-src={videoURL ? videoURL : getFilePath(video)} />
                        </video>
                        :
                        <Image className={mediaTabVideo} image={image} alt={alt} />
                    }
                  </div>
                  <div className={`${mediaTabButtonsContainer}`}>
                    <div className={`${mediaTabButtons} ${mediaTabButtonsMobile}  ${productsMediaTabButtons}`}>
                      <Swiper {...settings}>
                        {
                          variantsTab?.map((tab) => {
                            const { title, _key } = tab;

                            return (
                              <SwiperSlide key={_key} >
                                <div className={productsMediaItem} onClick={() => {
                                  setTabActive(_key);
                                  setSelectedTitle(title);
                                  trackTabClick(title);
                                }}>
                                  <div className={prodImage}>
                                    <img className={(tabActiveKey === null && index === 0) || (tabActiveKey === _key) ? fullOpacityImage : transparentImage} src={getImagePath(tab?.productImage)} />
                                  </div>
                                </div>
                              </SwiperSlide>
                            );
                          })
                        }

                        <button
                          className={`${mediaTabButtonsItem} ${selectedMediaItem}`}>
                          {selectedTitle}
                        </button>
                      </Swiper>
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
      </Container>
    </div>
  );
};

export default ProductsMediaTab;
